export const quiz =  {

    "appLocale": {
      "landingHeaderText": "CSS Assessment (<questionLength> Questions)",
      "question": "Question",
      "startQuizBtn": "Start Assessment",
      "resultFilterAll": "All",
      "resultFilterCorrect": "Correct",
      "resultFilterIncorrect": "Incorrect",
      "prevQuestionBtn": "Prev",
      "nextQuestionBtn": "Next",
      "resultPageHeaderText": "You have completed the assessment. You got <correctIndexLength> out of <questionLength> questions."
    },
  
    "quizTitle": "CSS",
    "quizSynopsis": "This assessment evaluates your knowledge of CSS selectors, properties, layout techniques, responsive design, and the fundamentals of styling web pages.",
    "nrOfQuestions": "50",
    "questions": [
  
      {
        "question": "What does CSS stand for?",
        "questionType": "text",
        "answerSelectionType": "single",
        "answers": [
          "Creative Style System",
          "Cascading Style Sheets",
          "Colorful Style Syntax",
          "Computer Style Sheet"
        ],
        "correctAnswer": "2",
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "CSS means Cascading Style Sheets",
        "point": "2"
      },
  
      {
        "question": "Which HTML tag is used to link an external CSS file?",
        "questionType": "text",
        "answerSelectionType": "single",
        "answers": [
          "<script>",
          "<css>",
          "<link>",
          "<style>"
        ],
        "correctAnswer": "3",
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "<link> is used for external stylesheets.",
        "point": "2"
      },
  
      {
        "question": "Which property is used to change text color?",
        "questionType": "text",
        "answerSelectionType": "single",
        "answers": [
          "font-color",
          "text-style",
          "color",
          "foreground"
        ],
        "correctAnswer": "3",
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "The color property changes text color.",
        "point": "2"
      },
  
      {
        "question": "Which of the following are valid CSS selectors?",
        "questionType": "text",
        "answerSelectionType": "multiple",
        "answers": [
          "#idSelector",
          ".classSelector",
          "element",
          "::pseudo-element"
        ],
        "correctAnswer": [1, 2, 3, 4],
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "All options represent valid selector types.",
        "point": "2"
      },
  
      {
        "question": "Which property is used to change the background color?",
        "questionType": "text",
        "answerSelectionType": "single",
        "answers": [
          "background-color",
          "bgcolor",
          "color-background",
          "background-style"
        ],
        "correctAnswer": "1",
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "background-color is correct.",
        "point": "2"
      },
  
      {
        "question": "Which unit is relative to the root font size?",
        "questionType": "text",
        "answerSelectionType": "single",
        "answers": [
          "px",
          "em",
          "rem",
          "%"
        ],
        "correctAnswer": "3",
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "rem is relative to the root font size.",
        "point": "2"
      },
  
      {
        "question": "Which of the following are CSS display values?",
        "questionType": "text",
        "answerSelectionType": "multiple",
        "answers": [
          "block",
          "inline",
          "flex",
          "in-between"
        ],
        "correctAnswer": [1, 2, 3],
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "block, inline, and flex are valid display values.",
        "point": "2"
      },
  
      {
        "question": "What property controls the size of text?",
        "questionType": "text",
        "answerSelectionType": "single",
        "answers": [
          "font-style",
          "font-size",
          "text-size",
          "size"
        ],
        "correctAnswer": "2",
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "font-size controls text size.",
        "point": "2"
      },
  
      {
        "question": "Which CSS property adds space inside an element?",
        "questionType": "text",
        "answerSelectionType": "single",
        "answers": [
          "margin",
          "padding",
          "border",
          "spacing"
        ],
        "correctAnswer": "2",
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "Padding adds space inside an element.",
        "point": "2"
      },
  
      {
        "question": "Which CSS property adds space outside an element?",
        "questionType": "text",
        "answerSelectionType": "single",
        "answers": [
          "padding",
          "border",
          "margin",
          "outline"
        ],
        "correctAnswer": "3",
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "Margin adds space outside the element.",
        "point": "2"
      },
  
      {
        "question": "Which value makes an element a flex container?",
        "questionType": "text",
        "answerSelectionType": "single",
        "answers": [
          "display: block",
          "display: flex",
          "display: inline-block",
          "display: inline-flex"
        ],
        "correctAnswer": "2",
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "display: flex creates a flex container.",
        "point": "2"
      },
  
      {
        "question": "Which CSS properties are used for Flexbox alignment?",
        "questionType": "text",
        "answerSelectionType": "multiple",
        "answers": [
          "justify-content",
          "align-items",
          "flex-align",
          "align-content"
        ],
        "correctAnswer": [1, 2, 4],
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "flex-align is not a valid property.",
        "point": "2"
      },
  
      {
        "question": "Which property is used to change the font family?",
        "questionType": "text",
        "answerSelectionType": "single",
        "answers": [
          "font-family",
          "font-name",
          "font-style",
          "family"
        ],
        "correctAnswer": "1",
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "font-family sets the font.",
        "point": "2"
      },
  
      {
        "question": "Which of the following are types of CSS?",
        "questionType": "text",
        "answerSelectionType": "multiple",
        "answers": [
          "External CSS",
          "Internal CSS",
          "Inline CSS",
          "Server CSS"
        ],
        "correctAnswer": [1, 2, 3],
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "Server CSS does not exist.",
        "point": "2"
      },
  
      {
        "question": "Which property controls the border thickness?",
        "questionType": "text",
        "answerSelectionType": "single",
        "answers": [
          "border-size",
          "border-width",
          "border-style",
          "thickness"
        ],
        "correctAnswer": "2",
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "border-width controls thickness.",
        "point": "2"
      },
  
      {
        "question": "Which CSS function is used for gradients?",
        "questionType": "text",
        "answerSelectionType": "single",
        "answers": [
          "color-gradient()",
          "gradient()",
          "linear-gradient()",
          "bg-gradient()"
        ],
        "correctAnswer": "3",
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "linear-gradient() is correct.",
        "point": "2"
      },
  
      {
        "question": "Which of the following are valid positioning values?",
        "questionType": "text",
        "answerSelectionType": "multiple",
        "answers": [
          "static",
          "relative",
          "fixed",
          "floating"
        ],
        "correctAnswer": [1, 2, 3],
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "floating is not valid.",
        "point": "2"
      },
  
      {
        "question": "Which property controls the stacking order of elements?",
        "questionType": "text",
        "answerSelectionType": "single",
        "answers": [
          "z-index",
          "stack",
          "layer",
          "position-index"
        ],
        "correctAnswer": "1",
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "z-index defines stacking order.",
        "point": "2"
      },
  
      {
        "question": "Which rule is used for media queries?",
        "questionType": "text",
        "answerSelectionType": "single",
        "answers": [
          "@device",
          "@media",
          "@screen",
          "@responsive"
        ],
        "correctAnswer": "2",
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "@media is used for responsive design.",
        "point": "2"
      },
  
      {
        "question": "Which properties control animation?",
        "questionType": "text",
        "answerSelectionType": "multiple",
        "answers": [
          "animation-name",
          "animation-duration",
          "animation-speed",
          "animation-delay"
        ],
        "correctAnswer": [1, 2, 4],
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "animation-speed does not exist.",
        "point": "2"
      },
  
      {
        "question": "Which property sets the width of an element?",
        "questionType": "text",
        "answerSelectionType": "single",
        "answers": [
          "element-width",
          "size-width",
          "width",
          "max-width"
        ],
        "correctAnswer": "3",
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "width sets the element width.",
        "point": "2"
      },
  
      {
        "question": "Which of the following are CSS length units?",
        "questionType": "text",
        "answerSelectionType": "multiple",
        "answers": [
          "px",
          "rem",
          "kg",
          "vh"
        ],
        "correctAnswer": [1, 2, 4],
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "kg is not a unit.",
        "point": "2"
      },
  
      {
        "question": "Which property hides an element but still takes up space?",
        "questionType": "text",
        "answerSelectionType": "single",
        "answers": [
          "display: none",
          "visibility: hidden",
          "opacity: 0",
          "hidden: true"
        ],
        "correctAnswer": "2",
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "visibility: hidden hides element but preserves layout.",
        "point": "2"
      },
  
      {
        "question": "Which property changes the cursor when hovering?",
        "questionType": "text",
        "answerSelectionType": "single",
        "answers": [
          "cursor",
          "pointer",
          "mouse-style",
          "hover"
        ],
        "correctAnswer": "1",
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "cursor property controls pointer style.",
        "point": "2"
      },
  
      {
        "question": "Which attributes allow CSS to be included inline?",
        "questionType": "text",
        "answerSelectionType": "single",
        "answers": [
          "inline",
          "css",
          "style",
          "styling"
        ],
        "correctAnswer": "3",
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "style attribute is used for inline CSS.",
        "point": "2"
      },
  
      {
        "question": "Which CSS properties are related to text formatting?",
        "questionType": "text",
        "answerSelectionType": "multiple",
        "answers": [
          "text-align",
          "text-decoration",
          "text-style",
          "text-transform"
        ],
        "correctAnswer": [1, 2, 4],
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "text-style does not exist.",
        "point": "2"
      },
  
      {
        "question": "Which is the correct syntax to center a block element?",
        "questionType": "text",
        "answerSelectionType": "single",
        "answers": [
          "margin: auto",
          "align: center",
          "center: true",
          "block-center"
        ],
        "correctAnswer": "1",
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "margin: auto centers block elements.",
        "point": "2"
      },
  
      {
        "question": "Which property controls rounded corners?",
        "questionType": "text",
        "answerSelectionType": "single",
        "answers": [
          "corner-radius",
          "border-round",
          "radius",
          "border-radius"
        ],
        "correctAnswer": "4",
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "border-radius adds rounded corners.",
        "point": "2"
      },
  
      {
        "question": "Which property controls spacing between letters?",
        "questionType": "text",
        "answerSelectionType": "single",
        "answers": [
          "letter-space",
          "spacing",
          "letter-spacing",
          "text-distance"
        ],
        "correctAnswer": "3",
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "letter-spacing sets character spacing.",
        "point": "2"
      },
  
      {
        "question": "Which values are valid for font-style?",
        "questionType": "text",
        "answerSelectionType": "multiple",
        "answers": [
          "normal",
          "italic",
          "bold-italic",
          "oblique"
        ],
        "correctAnswer": [1, 2, 4],
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "bold-italic is not valid.",
        "point": "2"
      },
  
      {
        "question": "Which property sets bold text?",
        "questionType": "text",
        "answerSelectionType": "single",
        "answers": [
          "font-weight",
          "font-bold",
          "weight",
          "text-bold"
        ],
        "correctAnswer": "1",
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "font-weight sets the boldness.",
        "point": "2"
      },
  
      {
        "question": "Which CSS rule imports external styles inside CSS?",
        "questionType": "text",
        "answerSelectionType": "single",
        "answers": [
          "@add",
          "@include",
          "@import",
          "@css"
        ],
        "correctAnswer": "3",
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "@import is used for importing CSS files.",
        "point": "2"
      },
  
      {
        "question": "Which CSS property controls overflow content?",
        "questionType": "text",
        "answerSelectionType": "single",
        "answers": [
          "scroll",
          "overflow",
          "content-overflow",
          "float-overflow"
        ],
        "correctAnswer": "2",
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "overflow handles hidden, scroll, auto.",
        "point": "2"
      },
  
      {
        "question": "Which values can overflow take?",
        "questionType": "text",
        "answerSelectionType": "multiple",
        "answers": [
          "visible",
          "hidden",
          "scroll",
          "show"
        ],
        "correctAnswer": [1, 2, 3],
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "show is not valid.",
        "point": "2"
      },
  
      {
        "question": "Which property defines the space between lines of text?",
        "questionType": "text",
        "answerSelectionType": "single",
        "answers": [
          "line-height",
          "height",
          "spacing",
          "text-line"
        ],
        "correctAnswer": "1",
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "line-height adjusts line spacing.",
        "point": "2"
      },
  
      {
        "question": "Which CSS property transforms text to uppercase?",
        "questionType": "text",
        "answerSelectionType": "single",
        "answers": [
          "text-format",
          "text-transform",
          "uppercase",
          "transform-text"
        ],
        "correctAnswer": "2",
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "text-transform: uppercase",
        "point": "2"
      },
  
      {
        "question": "Which properties are used to create transitions?",
        "questionType": "text",
        "answerSelectionType": "multiple",
        "answers": [
          "transition-property",
          "transition-duration",
          "transition-speed",
          "transition-delay"
        ],
        "correctAnswer": [1, 2, 4],
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "transition-speed does not exist.",
        "point": "2"
      },
  
      {
        "question": "Which property sets a shadow around text?",
        "questionType": "text",
        "answerSelectionType": "single",
        "answers": [
          "text-border",
          "text-shadow",
          "shadow-text",
          "font-shadow"
        ],
        "correctAnswer": "2",
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "text-shadow adds shadow effects.",
        "point": "2"
      },
  
      {
        "question": "Which property rotates an element?",
        "questionType": "text",
        "answerSelectionType": "single",
        "answers": [
          "transform",
          "rotate",
          "rotate-element",
          "skew"
        ],
        "correctAnswer": "1",
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "transform: rotate() is used.",
        "point": "2"
      },
  
      {
        "question": "Which CSS features support responsiveness?",
        "questionType": "text",
        "answerSelectionType": "multiple",
        "answers": [
          "media queries",
          "flexbox",
          "grid",
          "server queries"
        ],
        "correctAnswer": [1, 2, 3],
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "Server queries do not exist.",
        "point": "2"
      },
  
      {
        "question": "Which CSS layout system provides rows and columns?",
        "questionType": "text",
        "answerSelectionType": "single",
        "answers": [
          "float layout",
          "flexbox",
          "grid",
          "block layout"
        ],
        "correctAnswer": "3",
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "Grid creates rows & columns.",
        "point": "2"
      },
  
      {
        "question": "Which are valid grid properties?",
        "questionType": "text",
        "answerSelectionType": "multiple",
        "answers": [
          "grid-template-columns",
          "grid-template-rows",
          "grid-gap",
          "grid-inline-style"
        ],
        "correctAnswer": [1, 2, 3],
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "grid-inline-style does not exist.",
        "point": "2"
      },
  
      {
        "question": "Which rule gives priority to CSS declarations?",
        "questionType": "text",
        "answerSelectionType": "single",
        "answers": [
          "!important",
          "@priority",
          "css-override",
          "force-style"
        ],
        "correctAnswer": "1",
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "!important overrides other rules.",
        "point": "2"
      },
  
      {
        "question": "Which selector targets all paragraphs?",
        "questionType": "text",
        "answerSelectionType": "single",
        "answers": [
          ".p",
          "#p",
          "p",
          "*p"
        ],
        "correctAnswer": "3",
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "p selects all paragraphs.",
        "point": "2"
      },
  
      {
        "question": "Which selector targets all elements on a page?",
        "questionType": "text",
        "answerSelectionType": "single",
        "answers": [
          "all",
          "*",
          "any",
          "#"
        ],
        "correctAnswer": "2",
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "* is universal selector.",
        "point": "2"
      },
  
      {
        "question": "Which CSS property floats elements left or right?",
        "questionType": "text",
        "answerSelectionType": "single",
        "answers": [
          "float",
          "display",
          "position",
          "flex-direction"
        ],
        "correctAnswer": "1",
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "float positions elements horizontally.",
        "point": "2"
      },
  
      {
        "question": "Which properties are related to the box model?",
        "questionType": "text",
        "answerSelectionType": "multiple",
        "answers": [
          "margin",
          "padding",
          "border",
          "outline"
        ],
        "correctAnswer": [1, 2, 3, 4],
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "All belong to box model.",
        "point": "2"
      },
  
      {
        "question": "Which property defines the maximum width of an element?",
        "questionType": "text",
        "answerSelectionType": "single",
        "answers": [
          "width:max",
          "maxwidth",
          "max-width",
          "limit-width"
        ],
        "correctAnswer": "3",
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "max-width restricts width.",
        "point": "2"
      },
  
      {
        "question": "Which property makes text underlined?",
        "questionType": "text",
        "answerSelectionType": "single",
        "answers": [
          "text-decoration",
          "underline",
          "font-line",
          "text-line"
        ],
        "correctAnswer": "1",
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "text-decoration: underline",
        "point": "2"
      },
  
      {
        "question": "Which CSS property creates a shadow around a box?",
        "questionType": "text",
        "answerSelectionType": "single",
        "answers": [
          "box-shadow",
          "shadow",
          "border-shadow",
          "outline-shadow"
        ],
        "correctAnswer": "1",
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "box-shadow applies shadows.",
        "point": "2"
      },
  
      {
        "question": "Which properties can be animated?",
        "questionType": "text",
        "answerSelectionType": "multiple",
        "answers": [
          "color",
          "background-color",
          "width",
          "font-speed"
        ],
        "correctAnswer": [1, 2, 3],
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "font-speed does not exist.",
        "point": "2"
      },
  
      {
        "question": "Which option positions elements based on scroll movement?",
        "questionType": "text",
        "answerSelectionType": "single",
        "answers": [
          "position: scroll",
          "position: sticky",
          "position: float",
          "position: sliding"
        ],
        "correctAnswer": "2",
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "sticky sticks relative to scroll.",
        "point": "2"
      },
  
      {
        "question": "Which CSS rule defines keyframes for animation?",
        "questionType": "text",
        "answerSelectionType": "single",
        "answers": [
          "@animation",
          "@frames",
          "@keyframes",
          "@motion"
        ],
        "correctAnswer": "3",
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "@keyframes defines animation frames.",
        "point": "2"
      }
  
    ]
  }
  